"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_request_1 = require("graphql-request");
const endpoint = process.env.NEXT_PUBLIC_GRAPHQL_URI || 'http://localhost:1337/graphql' || '';
const credentials = (process.env.NEXT_PUBLIC_GRAPHQL_CREDENTIALS) || 'include';
const graphqlClient = (query, vars, headers) => new graphql_request_1.GraphQLClient(endpoint, {
    credentials,
    headers,
}).request(query, vars);
exports.default = graphqlClient;
